// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"4e18a11e","239":"95e97d9b","453":"64771e21","553":"b95a57e1","806":"717a4899","977":"678f16dd"}[chunkId] + ".chunk.js";
};